import meta from '../helper/meta';
import JSONParser from '../helper/json-parser';
import Logger from "./logger";
import TrackingHelper from './tracking/helper';

// trinity-Handlers
import click from './tracking/trinity/click';
import view from './tracking/trinity/view';
import page from './tracking/trinity/page';

const HANDLERS = {
    click,
    view,
    page
};
const TRINITY_CONTROLLER_URL = meta.value('trinity:url');

function initialize(element) {
    for (const trinityType in HANDLERS) {
        let trinityAttributeJson = element.getAttribute(`jsh-trinity__${trinityType}`);
        if (trinityAttributeJson === null) {
            continue;
        }
        trinityAttributeJson = sanitize(trinityAttributeJson);
        const trinityHandler = HANDLERS[trinityType];
        let parsedTrinityAttributes = JSONParser.tryParseJSON(trinityAttributeJson);
        if (parsedTrinityAttributes !== null) {
            trinityHandler(element, parsedTrinityAttributes, sendTrinityEvent);
        }
    }
}

function sendTrinityEvent(data) {
    sendTrinityEventAndCheckAttributes(data, true);
}

function sendTrinityEventWithoutAdditionalAttributes(data) {
    sendTrinityEventAndCheckAttributes(data, false);
}

function sendTrinityEventAndCheckAttributes(data, addAttributes) {
    const user = getUser();
    const event = {
        ...data,
        user: user,
        pageViewId: TrackingHelper.getPageViewId()
    };

    if (!event || !event.attributes || !event.schema) {
        Logger.error(`Invalid trinity event: missing attributes or schema\n\ttrinity event: ${event}`);
        return;
    }

    if (addAttributes) {
        if (event.attributes && !event.attributes.wkorbId) {
            event.attributes.wkorbId = TrackingHelper.getSessionId();
        }

        if (event.attributes && !event.attributes.pageViewId) {
            event.attributes.pageViewId = TrackingHelper.getPageViewId();
        }
    }

    if (!sendBeaconTrinity(`${TRINITY_CONTROLLER_URL}`, event)) {
        Logger.error(`Could not send trinity!\n\tReason: Unknown (beacon)\n\ttrinity event: ${event}`);
    }
}

export default {
    initialize,
    sendTrinityEvent,
    sendTrinityEventWithoutAdditionalAttributes
};

function getUser() {
    return {
        tenantId: TrackingHelper.getTenantId(),
        did: TrackingHelper.getDid(),
        sessionId: TrackingHelper.getSessionId(),
        uid: TrackingHelper.getUserId()
    };
}


function sanitize(inputString) {
    if (inputString === undefined) {
        return '';
    }
    return inputString.replace(/\r?\n|\r/g, "");
}

function sendBeaconTrinity(url, data) {
    // Do not change header type: https://stackoverflow.com/questions/45274021/sendbeacon-api-not-working-temporarily-due-to-security-issue-any-workaround
    //landmark=usage is important option for akamai bot whitelisting
    const headers = {type: 'application/json;landmark=usage'};
    const json = data ? JSON.stringify(data) : '{}';
    const dataBlob = new Blob([json], headers);
    return navigator.sendBeacon(url, dataBlob);
}
